export default __webpack_public_path__ + "static/roboto-v20-latin-ext-500-0b45721325446d537b545d6224819ad4.woff2";